<template>
  <div>
    <a-url-field
      varName="login_logout_options.login_url"
      varLabel="Login callback URL"
      :varRequired="true"
      :varInitial="data.login_logout_options.login_url"
      :formLayout="formLayout"
      :size="size"
      icon="link"
      description="Please provide default client login callback URL which will be used to redirect users to initiate the authorization process."
    />
    <a-url-field
      varName="login_logout_options.logout_url"
      varLabel="Logout redirect URL"
      :varRequired="true"
      :varInitial="data.login_logout_options.login_url"
      :formLayout="formLayout"
      :size="size"
      icon="link"
      description="Please provide default logout redirect URL which will be used to redirect users when either session is expired or there is no logout URL provided for the client."
    />
  </div>
</template>

<script>
export default {
  props: {
    formLayout: String,
    size: String,
    data: Object,
    form: Object
  }
};
</script>